// extracted by mini-css-extract-plugin
module.exports = {"root":"_2CPyo","wrapper":"_17IZ2","asterixWrapper":"Rn-UZ","title":"_2YfD1","subTitle":"_2tijy","device":"V_i1L","image":"_2RjJQ","description":"_1w_o8"};